import Backbone from 'init/backbone'
import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { Popup } from 'es6/libs/popup'
import * as urlHelper from 'helpers/url-helpers'
import * as redirectHelper from 'helpers/redirect-helper'
import { getTemplate } from 'helpers/template-helper'

@Defaults({
  additionalOptions: ['currentCurrency', 'router'],
  popupTemplate: '#currencies-popup',
  inputSelector: '.input-fake',
  popupSelector: '.currency-popup',
  events: {
    'click .js-currency-select': 'handleCurrencyClick',
  },
  chosenCurrency: null,
  /**
   * Текстовое представление валют, ключи объекта равны id валют.
   * @type {Object}
   */
  CURRENCY_TITLES: {
    1: 'Российский рубль',
    4: 'Белорусский рубль',
    3: 'Евро',
    2: 'Доллар США',
    5: 'Украинская гривна',
    6: 'Казахстанский тенге',
  },
})
class CurrenciesPopupSelectView extends View {
  /** @inheritDoc */
  run () {
    this.$input = this.$(this.inputSelector)
    this.initPopup()
    this.initTemplates()
    this.renderCurrencyInput()
    this.renderPopup()
    this.listenTo(Backbone, 'apply-currency', this.applyCurrency)
    if (!this.router) {
      this.listenToOnce(Backbone, 'router:inited', router => {
        this.router = router
      })
    }
  }

  /**
   * Инициализация попапа.
   */
  initPopup () {
    this.popup = new Popup(this.$(this.popupSelector), this.$input)
    this.popup.addEventListener(Popup.EventType.BEFORE_OPEN, this.toggleInputActiveState.bind(this, true))
    this.popup.addEventListener(Popup.EventType.BEFORE_CLOSE, this.toggleInputActiveState.bind(this, false))
  }

  /**
   * Смена состояния инпута.
   * @param {boolean} isActive Состояние инпута.
   */
  toggleInputActiveState (isActive) {
    this.$input.toggleClass('active', isActive)
  }
  /**
   * Инициализация шаблонов.
   */
  initTemplates () {
    this.popupTemplate = getTemplate(this.popupTemplate)
  }

  /**
   * Рендер попапа.
   */
  renderPopup () {
    const currenciesPopupHtml = this.popupTemplate({
      collection: this.collection.toJSON(),
      currencyTitles: this.CURRENCY_TITLES,
    })
    this.$(this.popupSelector).html(currenciesPopupHtml)
  }

  /**
   * Рендер валюты.
   * @param {string} currency Валюта.
   */
  renderCurrencyInput (currency = null) {
    const findBy = currency === null ? { current: true } : { name: currency },
      currentCurrencyModel = this.collection.findWhere(findBy),
      currencyId = currentCurrencyModel.get('id'),
      currencyTitle = this.CURRENCY_TITLES[currencyId]
    this.$input.html(`${currentCurrencyModel.get('grapheme')} ${currentCurrencyModel.get('name')} &mdash; ${currencyTitle}`)
  }

  /**
   * Обработка клика по валюте.
   * @param {jQuery.event} event Событие.
   */
  handleCurrencyClick (event) {
    this.chosenCurrency = $(event.currentTarget).data('currency')
    this.renderCurrencyInput(this.chosenCurrency)
    this.popup.close()
  }

  /**
   * Применение валюты.
   */
  applyCurrency () {
    if (this.chosenCurrency) {
      this.collection.setCurrent(this.chosenCurrency)
      Object.assign(this.currentCurrency, this.collection.getCurrent().toJSON())
      Backbone.trigger('change-currency')
      if (this.router) {
        this.router.navigate(
          this.router.getPathFragment(),
          {
            trigger: true,
          },
          {
            currency: this.chosenCurrency,
          }
        )
      } else {
        const urlParams = { ...urlHelper.getUrlParameters(), ...{ currency: this.chosenCurrency } }
        let url = urlHelper.to(urlHelper.getPathname(), [], urlParams)
        if (window.location.hash.length) {
          url += window.location.hash
        }
        redirectHelper.locationAssign(url)
      }
    }
  }
}

export default CurrenciesPopupSelectView
